import { get, send } from "../api.js";

export type TutorBookingContactField =
  | "parentName"
  | "parentEmail"
  | "parentPhone"
  | "studentEmail";

export type TutorBookingContactReason =
  | "no_payer_on_record"
  | "no_payer_email"
  | "payer_name_incomplete"
  | "school_not_configured"
  | "payer_link_conflict"
  | null;

export interface TutorBookingContactStatus {
  ready: boolean;
  editable: boolean;
  reason: TutorBookingContactReason;
  mode: "family" | "self" | null;
  missing_fields: TutorBookingContactField[];
}

export interface TutorBookingContactPatch {
  parentName?: string;
  parentEmail?: string;
  parentPhone?: string;
  studentEmail?: string;
}

/**
 * Read only the booking-readiness answer a staff booking flow needs.
 *
 * This deliberately does not expose the owner-facing payer projection, payer
 * identity or Amelia customer id. The Hub says whether the current record can
 * resolve a booking customer and, for the narrow tutor-created-student case,
 * which missing contact fields the tutor may fill before the first booking.
 */
export function getTutorBookingContact(
  studentId: string,
): Promise<TutorBookingContactStatus> {
  return get<TutorBookingContactStatus>(
    `/admin/students/${encodeURIComponent(studentId)}/booking-contact`,
  );
}

/**
 * Fill missing booking contact details on the tutor's own pristine student.
 * The Hub rejects payer changes, school/customer administration and edits to
 * already-populated identity fields even if a caller bypasses this type.
 */
export function updateTutorBookingContact(
  studentId: string,
  patch: TutorBookingContactPatch,
): Promise<TutorBookingContactStatus> {
  return send<TutorBookingContactStatus>(
    "PATCH",
    `/admin/students/${encodeURIComponent(studentId)}/booking-contact`,
    patch,
  );
}
